import { render, staticRenderFns } from "./UserFavoriteVenues.vue?vue&type=template&id=3e6d0378"
import script from "./UserFavoriteVenues.vue?vue&type=script&lang=ts"
export * from "./UserFavoriteVenues.vue?vue&type=script&lang=ts"
import style0 from "./UserFavoriteVenues.vue?vue&type=style&index=0&id=3e6d0378&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports